// create above as a web component
class CopyToClipboard extends HTMLElement {
  constructor() {
    super();
    this.text = this.getAttribute('data-clipboard-text');
    this.buttonText = this.querySelector('.btn-Button_Text');
    this.discount = this.getAttribute('data-clipboard-tex');
    this.initialiseCopyToClipboard();
  }

  initialiseCopyToClipboard() {
    this.querySelector('#copy-button').addEventListener('click', () => {
      this.copyToClipboard(this.text);
      this.buttonText.innerHTML = 'Copied!';
      // alert('Copied to clipboard');
    });
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.text);
  }

}
customElements.define('copy-to-clipboard', CopyToClipboard);    